import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useSearchFiltersContext } from "./filterContext";
// import { useSearchFiltersContext } from "./filterContext";
interface WrapperProps {
  analytics?: boolean;
  selected?: boolean;
}
const SearchFilterSelector = (props: Props) => {
  const {
    children,
    onClose,
    analytics,
    name,
    filters,
    dataFilters,
    setDataFilters,
  } = props;
  const { submit, reset } = useSearchFiltersContext();
  const toggleSortOrder = async () => {
    // const newSortOrder = dataFilters.sortOrder === "asc" ? "desc" : "asc";
    // sortSubmit(newSortOrder);
    const newSortOrder = dataFilters.sortOrder === "asc" ? "desc" : "asc";
    setDataFilters((prevFilters) => ({
      ...prevFilters,
      sortOrder: newSortOrder,
    }));
  };
  return (
    <Wrapper analytics={analytics}>
      <Heading>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {name}
          {name == "Sort By" && (
            <div style={{ display: "flex" }}>
              {Object.entries(filters || {}).map(([key, value]) => (
                <OrderButton
                  onClick={() => {
                    if (
                      key == dataFilters.sortOrder[0] ||
                      null ||
                      key == dataFilters.sortOrder ||
                      null
                    ) {
                    } else {
                      toggleSortOrder();
                    }
                  }}
                  selected={
                    key == dataFilters.sortOrder[0] ||
                    null ||
                    key == dataFilters.sortOrder ||
                    null
                  }
                  key={key}
                >
                  {value as string}
                </OrderButton>
              ))}
            </div>
          )}
        </div>
        {!analytics && (
          <IconButton
            type="button"
            onClick={() => {
              submit();
              onClose();
            }}
          >
            <FontAwesomeIcon size="sm" icon={faTimes} />
          </IconButton>
        )}
        {analytics && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <>
              {name != "Sort By" && (
                <ResetButton
                  type="button"
                  onClick={() => {
                    reset();
                    onClose();
                  }}
                >
                  Reset
                </ResetButton>
              )}
              <ApplyButton
                type="button"
                onClick={() => {
                  submit();
                  onClose();
                }}
              >
                Apply
              </ApplyButton>
            </>
          </div>
        )}
      </Heading>
      <FilterPopup id="SearchWrapper">{children}</FilterPopup>
    </Wrapper>
  );
};

const Wrapper = styled.div<WrapperProps>`
  background: white;
  position: absolute;
  left: ${(props) => (props.analytics ? "0" : "auto")};
  right: ${(props) => (props.analytics ? "auto" : "0")};
  white-space: nowrap;
  z-index: 2;
  margin-top: 1rem;
  border: ${({ theme }) =>
    theme ? `1px solid ${theme?.colors?.gray200}` : "1px solid #E5E7EB"};
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  min-width: 250px;
  width: 500px;
  color: ${({ theme }) => (theme ? theme?.colors?.text : "#1F2937")};

  @media (max-width: 700px) {
    position: fixed;
    width: auto;
    left: 1rem;
    right: 1rem;
    top: ${(props) => (props.analytics ? "200px" : "200px")};
    bottom: 70px;
  }
`;
const FilterPopup = styled.div<WrapperProps>`
  white-space: nowrap;
  z-index: 2;
  margin-top: 72px;
  max-height: 50vh;
  overflow: auto;
  padding: 0px;
  background: white;
`;

const Heading = styled.div`
  font-size: 18px;
  padding: 0 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  top: 0px;
  padding: 20px 20px;
  border-bottom: 1px solid #e5e7eb;
`;

const IconButton = styled.button`
  appearance: none;
  border: none;
  background: none;
  position: absolute;
  right: 0;
  top: 0;
  padding: 1rem 1.5rem;
  color: ${({ theme }) => theme?.colors?.muted};
`;

const ApplyButton = styled.button`
  background: #79D9D9;
  border: 1px solid #79D9D9;
  padding: 5px 20px;
  font-size: 14px;
  color: white;
  font-weight: bold;
`;

const ResetButton = styled.button`
  background: transparent;
  border: 1px solid #79D9D9;
  padding: 5px 20px;
  font-size: 14px;
  color: #79D9D9;
  font-weight: bold;
`;

const OrderButton = styled.div<WrapperProps>`
  background: ${(props) => (props.selected ? "#79D9D9" : "transparent")};
  border: 1px solid #79D9D9;
  padding: 5px 20px;
  font-size: 14px;
  cursor: ${(props) => (props.selected ? "not-allowed" : "pointer")};
  color: ${(props) => (props.selected ? "white" : "#79D9D9")};
  font-weight: bold;
`;

type Props = {
  children: React.ReactNode;
  onClose: () => void;
  analytics?: boolean;
  name?: string;
  filters?: any;
  setDataFilters?: any;
  dataFilters?: any;
};

export default SearchFilterSelector;
